import React, { Component } from 'react';
import i18n from 'i18n-react';

import clsx from 'clsx';
import ReactTooltip from 'react-tooltip';
import { capitalize } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  APIHandler,
  DataHandler,
  PointsDisplay,
  PointsAlert,
  PointsHandler,
  StorageHandler,
  SubAppButton,
  SweetAlert,
  TrainingCard,
  Progress
} from 'C4';
import { baseAppId, storageKeys, points, imgixUrl } from 'settings';

import badgeBronze from 'assets/images/bronze_badge.png';
import badgeGold from 'assets/images/golden_badge.png';
import badgeSilver from 'assets/images/silver_badge.png';
import badges from 'assets/images/badges';

const badgePlat = badgeSilver;

const fancybox = {
  'data-fancybox': true,
  'data-src': '#diploma',
  'data-options': JSON.stringify({ toolbar: 'true', buttons: ['close'] }),
};

const sendBronzeMail = async () => {
  const appId = await DataHandler.matchAppId();

  if (appId === 808) {
    const user = await StorageHandler.load(storageKeys.user) || {};
    if (user) {
      const { email } = user;
      await APIHandler.updateUser('caDeBronze', email, [
        { param: 'sales_companion_registered', val: Date.now()},
      ]);
    }
  }
}

const SubProgressBar = ({ type, chapters, chaptersProgress }) => {
  const chaptersProgressPercentage = [];
  
  chapters.map(item => {
    chaptersProgress.filter(progress => {
      return progress.chapter === item.chapterID
    }).map(progressItem => {
      chaptersProgressPercentage.push(progressItem.percentage);
    })
  })
      
  let chapterProgress = 0;
  if (chaptersProgressPercentage.length > 0) {
    const numberOfChapters = chaptersProgressPercentage.length;
    const maxPercentage = numberOfChapters * 100;
    let totalPercentagesCombined = 0;
    chaptersProgressPercentage.forEach(percentage => {
      if (percentage !== undefined) {
        totalPercentagesCombined += percentage;
      }
    });
    
    chapterProgress = Math.floor((100 / maxPercentage) * totalPercentagesCombined);

    // Send email if first four chapters are completed
    if (type === 'bronze' && chapterProgress >= 100) {
      sendBronzeMail();
    }
  }

  return (
    <div className={`subprogress ${type}`}>
      <Progress id="subprogress" value={chapterProgress} rounded={true} />
      <p>{chapterProgress} {i18n.translate('trainingScreens.percentageComplete')}</p>
    </div>
  )
}

export default class TrainingGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appId: 0,
      chapters: [],
      chapters_progress: [],
      pdfShown: true,
      subApps: [],
      swal: [],
      swalOpen: false,
      diploma: 0,
      completedSubApps: [],
      totalItemCount: 0,
      totalItemCountCompleted: 0,
      userCountry: '',
    };

    this.isLocked = this.isLocked.bind(this);
    this.loadChapters = this.loadChapters.bind(this);
    this.calculateProgress = this.calculateProgress.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.getProgress();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  async getProgress() {
    StorageHandler.load(storageKeys.lang).then((lang) => {
      this.setState({ userCountry: lang.code });
    });
    
    const user = await StorageHandler.load(storageKeys.user);
    if (user) {
      const { email } = user;
      const { appId } = window;
      if (this.mounted) {
        this.setState({ appId });
        const userProgress = await APIHandler.getUserProgress(appId, email);
        await this.calculateProgress(userProgress);
      }
    }
  }

  getTieredValue(array = null) {
    const { tiers, totalPoints } = this.pointsHandler;

    let index = 0;
    tiers.forEach(({ points: tierPoints }, i) => {
      // Could be improved, maybe using filter / reduce?
      if (totalPoints >= tierPoints) {
        index = i;
      }
    });

    if (array) return array[index < 0 ? 0 : index];
    return index;
  }

  async getSubAppProgress(appIds) {
    const user = await StorageHandler.load(storageKeys.user);
    if (user) {
      const { email } = user;

      if (this.mounted && appIds.length > 0) {
        const { data } = await APIHandler.getUserProgress(appIds, email);
        return (
          (data &&
            Object.values(data).map(({ chapters: [chapter], name, region_hidden }) => ({
              chapter,
              name,
              region: region_hidden,
            }))) ||
          []
        );
      }
    }
    return null;
  }

  async setSubApps(appId) {
    const { userCountry } = this.state;
    const user = await StorageHandler.load(storageKeys.user);
    if (user) {
      const { email } = user;

    const ids = await APIHandler.getSubApps(appId);
    const appIds = ids[0].sessions.map(function(item) {
      return item['session_app_id'];
    });
    const progress = await this.getSubAppProgress(appIds);
    
    if (progress) {
      const subAppPromises = appIds.map(async (id, i) => {
        const {
          chapter,
          name,
          region,
          chapter: { last_page: lastPage, total_pages: totalPages },
        } = progress[i];

        const pageId = lastPage < totalPages ? lastPage : 0;

        const {
          app: [newApp],
        } = await APIHandler.getChapters(id);
        const { chapterID, chapterImage } = newApp;

        const backgroundImageSrc = `${imgixUrl}${id}/${chapterImage}?fit=crop&w=257&h=210`;

        console.log(progress[i]);
        if (progress[i].region === 1 && (userCountry === 'caEn' || userCountry === 'caFr')) {
          return;
        }

        return (
          <SubAppButton
            key={chapterID}
            appId={id}
            progress={chapter}
            name={name}
            pageId={pageId}
            size={{ height: 100, width: 100 }}
            type="training"
            email={email}
            chapterId={chapterID}
            backgroundImage={backgroundImageSrc}
          />
        );
      });

      if (this.mounted) {
        const subApps = await Promise.all(subAppPromises);
        const completedSubApps = progress
          .filter(({ chapter: { progress: subProgress, total_pages: totalPages } }) =>
            Math.floor(subProgress / totalPages) * 100 >= 100)
          .map(({ chapter }) => chapter);
        this.setState({ subApps, completedSubApps });
      }
      return null;
    }
  }
    this.setState({ subApps: [] });
    return null;
  }

  async handlePoints() {
    const {
      chapters_progress: progress, chapters, subApps, completedSubApps, swal,
    } = this.state;
    const { introChapters } = points;

    const intro = progress
      .filter((chapter, i) =>
        introChapters // Filter progress to just the introChapters
          .some(val => +new RegExp('(.*?-)*(?<index>[0-9]+)', 'g').exec(val).groups.index === i + 1))
      .filter(({ percentage }) => percentage && percentage >= 100);

    const rest = progress
      .filter((chapter, i) =>
        introChapters // Filter introChapters
          .every(val => +new RegExp('(.*?-)*(?<index>[0-9]+)', 'g').exec(val).groups.index !== i + 1))
      .filter(({ percentage }) => percentage && percentage >= 100);

    if (chapters && this.pointsHandler.tiers) {
      const introsComplete = intro.map(({ chapter }) => this.updatePoints('intro-chapter', chapter));
      const chaptersComplete = rest.map(({ chapter }) => this.updatePoints('chapter', chapter));
      const subAppsComplete = completedSubApps.map(({ chapter }) => this.updatePoints('subapp', chapter));

      const allUpdates = await Promise.all([introsComplete, chaptersComplete, subAppsComplete].flat());
      const totalPointsGained = [...allUpdates.map(({ points: p }) => p), 0].reduce((total, pointsGained) => total + pointsGained);

      if (!Number.isNaN(totalPointsGained) && totalPointsGained > 0) {
        const [{ copy, points: firstPoints }] = allUpdates.filter(({ points: p }) => p > 0);
        const { tiers, totalPoints } = this.pointsHandler;

        const newSwal = [...swal];
        newSwal.push({
          title: copy,
          imageUrl: badges[`badge${firstPoints}`],
          imageWidth: 110,
          imageAlt: `+${firstPoints}XP`,
          showCloseButton: true,
          icon: '',
          html: (
            <PointsAlert
              key={JSON.stringify(points)}
              tiers={tiers}
              points={totalPoints}
              pointsGained={totalPointsGained}
              delay={750}
            />
          ),
          onClose: () => {
            this.setState(
              ({ swal: swalState }) => ({ swalOpen: false, swal: swalState.slice(1) }),
              () => {
                const { swal: swalState } = this.state;
                if (swalState.slice(1).length > 0) {
                  this.setState({ swalOpen: true });
                }
              },
            );
          },
        });
        this.setState({ swal: newSwal, swalOpen: true });
      }

      const allItemsCompleted = [introsComplete.length, chaptersComplete.length, subAppsComplete.length];
      const allItems = [chapters.length, subApps.length];

      const totalItemCountCompleted = allItemsCompleted.reduce((total, len) => total + len);
      const totalItemCount = allItems.reduce((total, len) => total + len);

      this.setState({ totalItemCountCompleted, totalItemCount });
    }
  }

  async updatePoints(action, i) {
    const { totalPoints, tiers } = this.pointsHandler;
    const { points: maxedPoints } = tiers[tiers.length - 1];

    const userIsMaxed = totalPoints >= maxedPoints;

    if (!userIsMaxed) {
      const { response } = await this.pointsHandler.setPoints({
        action,
        value: `${action}-${i}`,
      });

      if (response !== 'Already used') {
        const { update } = response;

        return update;
      }
    }
    return { points: 0 };
  }

  async initPointsHandler() {
    this.pointsHandler = new PointsHandler();
    await this.pointsHandler.init();
    await this.pointsHandler.getPoints();
  }

  async loadChapters(setProgress) {
    const { appId, userCountry } = this.state;

    const { app } = await APIHandler.getChapters(appId);
    let bronzeCount = 4;
    if (userCountry === 'caFr' || userCountry === 'caEn') {
      bronzeCount = 3;
    }
    if (!setProgress) {
      const user = await StorageHandler.load(storageKeys.user);
      const registered = await APIHandler.registerUserProgress(user.email);
      if (registered) this.getProgress();
    } else {
      const { chapters_progress: chaptersProgress } = this.state;
      const chapters = app.map((chapter, i) => (
        <React.Fragment key={chapter.chapterID}>
          {i === 0 && (
            <div className="subheader">
              <h1>{i18n.translate('trainingScreens.essential')}</h1>
              <h2>{i18n.translate('trainingScreens.essentialSub')}</h2>
              <img className="badge" src={badgeBronze} alt="bronze badge" />
              <SubProgressBar type="bronze" chapters={app.slice(0, bronzeCount)} chaptersProgress={chaptersProgress} />
            </div>
          )}
          {i === 4 && (
            <div className="subheader sub">
              <h1>{i18n.translate('contentHeaders.subtrainings')}</h1>
              <h2>{i18n.translate('pageDescriptions.subtrainings')}</h2>
              <img className="badge" src={badgeSilver} alt="silver badge" />
              <SubProgressBar type="silver" chapters={app.slice(4, 10)} chaptersProgress={chaptersProgress} />
            </div>
          )}
          {((i !== 3 && userCountry === 'caFr') || (i !== 3 && userCountry === 'caEn') || (userCountry !== 'caEn' && userCountry !== 'caFr')) && 
          <div
            key={chapter.chapterID}
            className={clsx('trainingCard__Animated', {
              specialization: i >= 4,
            })}
          >
            <TrainingCard
              chaptersProgress={chaptersProgress[i]}
              chapter={chapter}
              chapterCount={chapter.chapterItemCount}
              locked={this.isLocked(i)}
              index={i}
              appId={appId}
              key={chapter.chapterID}
            />
          </div>}
        </React.Fragment>
      ));
      this.setState({ chapters }, async () => {
        await this.initPointsHandler();
        await this.setSubApps(appId);
        await this.handlePoints();
      });
    }
  }

  calculateProgress(res) {
    if (res.status !== 'error') {
      const { chapters } = res.data[0];
      chapters.forEach((chapter) => {
        const newChapter = chapter;
        if (chapter.progress > 0 && chapter.total_pages > 0) {
          newChapter.percentage = ((chapter.progress + 1) / chapter.total_pages) * 100;
          if (newChapter.percentage > 100) {
            newChapter.percentage = 100;
          }
        }
      });


      this.setState({ chapters_progress: chapters }, () => {
        this.loadChapters(res.status !== 'error');
      });
    } else {
      this.loadChapters(res.status !== 'error');
    }
  }

  isLocked(key) {
    const { chapters_progress: progress, userCountry } = this.state;

    // if (key >= 8 && (userCountry === 'caEn' || userCountry === 'caFr' || userCountry === 'fr')) {
    //   return true;
    // }

    // if (key >= 8 && (userCountry === 'de')) {
    //   return true;
    // }

    return false;
  }

  render() {
    const {
      chapters, subApps, pdfShown, swal, swalOpen, totalItemCountCompleted, totalItemCount, userCountry
    } = this.state;

    const { tierBadges } = badges;
    const { initialized, tiers, totalPoints } = this.pointsHandler || {};
    const tierIndex = tiers && Math.min(this.getTieredValue(), tiers.length - 1);

    return (
      <div>
        {swal && swal.length > 0 && tiers && <SweetAlert trigger={swalOpen} {...(Array.isArray(swal) && swal[0])} />}
        {initialized &&
          tiers && ( // Wrap in own component?
            <div className="wrapper__bars">
              <div className="inner">
                <img src={Object.values(tierBadges)[tierIndex]} className="points--logo" alt="Logo" />
                <span>
                  {i18n.translate('trainingScreens.status')} {`${tiers[tierIndex].title}`}
                </span>
                <ReactTooltip />
                <hr />
                <span>
                  <PointsDisplay
                    orientation="vertical"
                    tiers={tiers.map(({ points: p }) => p)}
                    labels={tiers.map(({ title }) => capitalize(title))}
                    minSize="40rem"
                    points={425}
                    segmented
                  />
                </span>
                <span>
                  {i18n.translate('points.completed', { completed: totalItemCountCompleted, total: totalItemCount })}
                </span>
              </div>
            </div>
          )}
        {(chapters || subApps) && (
          <div>
            <div className="trainingGrid">{chapters}</div>
             <React.Fragment>
              <div className="trainingGrid subApps">
              {subApps.length > 0 && <div className="subheader">
                  <h1>{i18n.translate('contentHeaders.subapps')}</h1>
                  <h2>{i18n.translate('pageDescriptions.subapps')}</h2>
                  <img className="badge" src={badgeGold} alt="gold badge" />
                </div>}
              </div>
              <div className="trainingGrid subApps">{subApps}</div>
            </React.Fragment>
          </div>
        )}
      </div>
    );
  }
}
